export const validateImageFile = (
    file: File,
): {
    valid: boolean;
    error?: string;
} => {
    const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    const ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

    if (!ALLOWED_TYPES.includes(file.type)) {
        return {
            valid: false,
            error: 'Only JPEG and PNG images are allowed',
        };
    }

    if (file.size > MAX_SIZE) {
        return {
            valid: false,
            error: 'Image must be smaller than 5MB',
        };
    }

    return { valid: true };
};
